import React from "react";
import { Alert } from "react-bootstrap";
import { useAuth } from "../../../app/providers/AuthProvider";
import { OwnerDashboard } from "./OwnerDashboard";
import { TeacherDashboard } from "./TeacherDashboard";
import { StudentDashboard } from "./StudentDashboard";

/**
 * Dashboard — role dispatcher (TASK-07).
 *
 * Renders the correct role-specific dashboard based on the JWT claim.
 * All three roles land here at /{slug}/app/dashboard after login.
 *
 * Routing map for downstream features:
 *   OWNER   → OwnerDashboard   → /{slug}/app/academia/...   (TASK-09)
 *   TEACHER → TeacherDashboard → /{slug}/app/agenda/...     (TASK-12)
 *   STUDENT → StudentDashboard → /{slug}/app/mi-espacio/... (TASK-14)
 *
 * Owner billing/fees (TASK-16) hangs at /{slug}/app/honorarios/...
 * Super-admin (TASK-18) hangs at /{slug}/app/admin/...
 */
const ROLE_DASHBOARDS = {
  OWNER: OwnerDashboard,
  TEACHER: TeacherDashboard,
  STUDENT: StudentDashboard,
};

function Dashboard() {
  const { role } = useAuth();
  const RoleDashboard = role ? ROLE_DASHBOARDS[role] : null;

  if (!RoleDashboard) {
    return (
      <Alert variant="warning" className="mt-3">
        Rol no reconocido: <strong>{role ?? "ninguno"}</strong>. Contacta al
        administrador de tu academia.
      </Alert>
    );
  }

  return <RoleDashboard />;
}

export { Dashboard };
